/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { cardMessages as messages } from '@atlaskit/editor-common/messages';
import { FloatingToolbarButton as Button, FloatingToolbarSeparator as Separator, SmallerEditIcon } from '@atlaskit/editor-common/ui';
import { canRenderDatasource, getDatasourceType } from '@atlaskit/editor-common/utils';
import { Flex } from '@atlaskit/primitives';
import { showDatasourceModal } from '../pm-plugins/actions';
import { CardContextProvider } from './CardContextProvider';
import { useFetchDatasourceInfo } from './useFetchDatasourceInfo';
var buttonStyles = css({
  pointerEvents: 'auto'
});

// Edit button in toolbar to open datasource modal. This button is shown for inline, block, and embed cards
// if they can resolve into a datasource.
var EditDatasourceButtonWithCardContext = function EditDatasourceButtonWithCardContext(_ref) {
  var cardContext = _ref.cardContext,
    intl = _ref.intl,
    editorAnalyticsApi = _ref.editorAnalyticsApi,
    url = _ref.url,
    editorView = _ref.editorView,
    editorState = _ref.editorState;
  var _useFetchDatasourceIn = useFetchDatasourceInfo({
      isRegularCardNode: true,
      url: url,
      cardContext: cardContext
    }),
    datasourceId = _useFetchDatasourceIn.datasourceId;
  if (!datasourceId || !canRenderDatasource(datasourceId, false)) {
    return null;
  }
  if (url) {
    var _cardContext$store, _urlState$error;
    var urlState = cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url];
    if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') {
      return null;
    }
  }
  var dispatchCommand = function dispatchCommand(fn) {
    fn && fn(editorState, editorView && editorView.dispatch);
    if (editorView && !editorView.hasFocus()) {
      editorView.focus();
    }
  };
  return jsx(Flex, null, jsx(Button, {
    css: buttonStyles,
    title: intl.formatMessage(messages.datasourceTitle),
    icon: jsx(SmallerEditIcon, null),
    selected: false,
    onClick: function onClick() {
      return dispatchCommand(editDatasource(datasourceId, editorAnalyticsApi));
    },
    testId: 'card-edit-datasource-button'
  }), jsx(Separator, null));
};
export var EditDatasourceButton = function EditDatasourceButton(_ref2) {
  var intl = _ref2.intl,
    editorAnalyticsApi = _ref2.editorAnalyticsApi,
    url = _ref2.url,
    editorView = _ref2.editorView,
    editorState = _ref2.editorState;
  return jsx(CardContextProvider, null, function (_ref3) {
    var cardContext = _ref3.cardContext;
    return jsx(EditDatasourceButtonWithCardContext, {
      url: url,
      intl: intl,
      editorAnalyticsApi: editorAnalyticsApi,
      editorView: editorView,
      editorState: editorState,
      cardContext: cardContext
    });
  });
};
export var editDatasource = function editDatasource(datasourceId, editorAnalyticsApi) {
  return function (state, dispatch) {
    var datasourceType = getDatasourceType(datasourceId);
    if (dispatch && datasourceType) {
      var tr = state.tr;
      showDatasourceModal(datasourceType)(tr);
      // editorAnalyticsApi?.attachAnalyticsEvent(
      //   buildEditLinkPayload(
      //     type as
      //       | ACTION_SUBJECT_ID.CARD_INLINE
      //       | ACTION_SUBJECT_ID.CARD_BLOCK
      //       | ACTION_SUBJECT_ID.EMBEDS,
      //   ),
      // )(tr);
      dispatch(tr);
      return true;
    }
    return false;
  };
};